import { Component } from '@angular/core';

@Component({
  selector: 'app-consumidor-list',
  templateUrl: './consumidor-list.component.html',
  styleUrls: []
})
export class ConsumidorListComponent {

}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-list/consumidor-list.component.ts